<ng-container *ngIf="allRedy">
  <div
    id="content-to-export"
    *appHasPermission="'dashboard_module'"
    class="d-flex flex-column justify-content-start align-content-stretch h-100 gap-3 overflowy-scroll bg-light"
    style="max-height: 100%"
  >
    <!-- Filtro -->
    <div
      class="d-flex flex-wrap justify-content-center align-content-center gap-3 m-3"
    >
      <div
        *appHasPermission="'dashboard_filterPeriods'"
        class="btn-toolbar d-flex flex-wrap gap-3 justify-content-center"
        role="toolbar"
        aria-label="Toolbar with button groups"
      >
        <div
          *ngFor="let period of periods"
          class="btn-group"
          style="width: 6rem"
          role="group"
          aria-label="groups"
        >
          <input
            type="radio"
            class="btn-check"
            [name]="btnradio"
            [id]="period.id"
            autocomplete="off"
            [checked]="period.checked || false"
            (click)="setPeriod(period)"
            [disabled]="period.disabled"
          />
          <label
            class="btn btn-outline-primary btn-sm text-nowrap overflow-hidden text-truncate"
            [for]="period.id"
            pTooltip="{{ period.name }}"
            tooltipPosition="bottom"
            style="font-size: 0.8rem; align-content: center"
          >
            {{ period.name }}
          </label>
        </div>
      </div>
      <div
        class="d-flex flex-wrap gap-3 align-items-center justify-content-center"
      >
        <div
          *appHasPermission="'dashboard_filterDatetime'"
          class="d-flex gap-2 align-self-center"
        >
          <p class="m-auto">Desde:</p>
          <p-calendar
            [(ngModel)]="period.start"
            dateFormat="dd/mm/yy"
            [maxDate]="period.end"
            [minDate]="limitDate"
            [appendTo]="'body'"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2020:2030"
            [showTime]="true"
            [inputStyleClass]="'p-1 glt-input-cw-dt'"
            (onSelect)="checkDates()"
          ></p-calendar>
        </div>
        <div
          *appHasPermission="'dashboard_filterDatetime'"
          class="d-flex gap-2 align-self-center"
        >
          <p class="m-auto">Hasta:</p>
          <p-calendar
            class=""
            [(ngModel)]="period.end"
            dateFormat="dd/mm/yy"
            [minDate]="period.start"
            [appendTo]="'body'"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2020:2030"
            [showTime]="true"
            [inputStyleClass]="'p-1 glt-input-cw-dt'"
            (onSelect)="checkDates()"
          ></p-calendar>
        </div>
        <div
          *appHasPermission="'dashboard_filterOperation'"
          class="d-flex flex-row gap-2 align-self-center"
        >
          <p class="m-auto flex-none">Filtrar por:</p>
          <p-multiSelect
            [options]="operations"
            optionLabel="name"
            defaultLabel="Seleccione una operacion"
            selectedItemsLabel="{0} operationes"
            maxSelectedLabels="1"
            [showHeader]="false"
            [style]="{ width: '160px' }"
            (onChange)="onChangeUnitOperation($event)"
          ></p-multiSelect>
        </div>
      </div>
      <div class="d-flex flex-wrap align-self-center gap-3">
        <div class="btn btn-sm btn-primary m-0 p-0">
          <button
            *appHasPermission="'dashboard_setFilter'"
            class="btn btn-sm btn-primary"
            style="width: 6rem"
            (click)="dashboardService.getAllRequest()"
          >
            Aplicar
          </button>
          <button
            *appHasPermission="'dashboard_optionsExport'"
            class="btn btn-sm btn-primary"
            (click)="export.toggle($event)"
          >
            <i class="pi pi-ellipsis-v"></i>
          </button>
          <p-menu #export [popup]="true" [model]="items"></p-menu>
        </div>
      </div>
    </div>
    <div style="overflow-y: scroll">
      <!-- Graficos en tiempo real -->
      <div
        *appHasPermission="'dashboard_driveTxStatuses'"
        style="padding: 0 5%"
        class="d-flex flex-column justify-content-center align-content-center"
      >
        <div
          class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3 w-100"
        >
          <button
            pButton
            pRipple
            type="button"
            (click)="showUnitsTxStates()"
            [icon]="
              areDriveTxStatusesDisplayed
                ? 'pi pi-chevron-up'
                : 'pi pi-chevron-down'
            "
            class="p-button-sm p-button-rounded p-button-text"
            style="color: #6c757d"
          ></button>
          <div
            class="text-uppercase fw-light text-nowrap overflow-hidden text-truncate"
            style="font-size: 1.5rem"
          >
            Estados de Transmisión de las unidades
          </div>
          <div
            class="align-content-center position-relative"
            style="color: #6c757d"
          >
            <svg
              width="28"
              height="28"
              fill="currentColor"
              viewBox="0 0 16 16"
              style="animation: spin 15s linear infinite"
            >
              <path
                d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"
              />
              <path
                fill-rule="evenodd"
                d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
              />
            </svg>
            <span class="static-number">15s</span>
          </div>
        </div>

        <app-charts-transmission-states
          *ngIf="areDriveTxStatusesDisplayed"
        ></app-charts-transmission-states>
      </div>
      <!-- Graficos historicos -->
      <div
        *appHasPermission="'dashboard_descriptiveGraphic'"
        style="padding: 0 5%"
        class="d-flex flex-column justify-content-center align-content-center"
      >
        <div
          class="d-flex flex-row justify-content-center align-self-start gap-3 mb-3 px-3"
        >
          <button
            pButton
            pRipple
            type="button"
            (click)="showDescriptiveGraphic()"
            [icon]="
              areDescriptiveGraphicDisplayed
                ? 'pi pi-chevron-up'
                : 'pi pi-chevron-down'
            "
            class="p-button-sm p-button-rounded p-button-text"
            style="color: #6c757d"
          ></button>
          <div class="text-uppercase fw-light" style="font-size: 1.5rem">
            Gráficos Históricos
          </div>
          <div class="align-content-center position-relative"></div>
        </div>
        <app-charts-descriptive-statistics
          *ngIf="areDescriptiveGraphicDisplayed"
        ></app-charts-descriptive-statistics>
      </div>
      <!-- Graficos predictivos -->
      <div
        *appHasPermission="'dashboard_predictiveGraphic'"
        style="padding: 0 5%"
        class="d-flex flex-column justify-content-center align-content-center"
      >
        <div
          class="d-flex flex-row justify-content-center align-self-start gap-3 mb-3 px-3"
        >
          <button
            pButton
            pRipple
            type="button"
            (click)="showPredictiveGraphic()"
            [icon]="
              arePredictiveGraphicDisplayed
                ? 'pi pi-chevron-up'
                : 'pi pi-chevron-down'
            "
            class="p-button-sm p-button-rounded p-button-text"
            style="color: #6c757d"
          ></button>
          <div class="text-uppercase fw-light" style="font-size: 1.5rem">
            Graficos Predictivos
          </div>
          <div class="align-content-center position-relative"></div>
        </div>
        <div *ngIf="arePredictiveGraphicDisplayed">
          Replazame por los graficos predictivos
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="false" class="h-100">
    <div class="w-100 h-100 d-flex justify-content-center align-content-center">
      <div
        class="d-flex flex-column justify-content-center align-content-center align-items-center"
      >
        <div>
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <div class="d-flex flex-row gap-2">
          <div>Cargando</div>
          <div>datos</div>
          <div>...</div>
        </div>
      </div>
    </div>
  </div>
  <div class="h-100" *appHasPermission="'!dashboard_module'">
    <div class="w-100 h-100 d-flex justify-content-center align-content-center">
      <div
        class="d-flex flex-column justify-content-center align-content-center align-items-center"
      >
        <div>
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <div class="d-flex flex-row gap-2">
          <div>No cuentas con permisos para acceder a este contenido</div>
          <div>...</div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!allRedy">
  <div class="h-100" *appHasPermission="'!dashboard_module'">
    <div class="w-100 h-100 d-flex justify-content-center align-content-center">
      <div
        class="d-flex flex-column justify-content-center align-content-center align-items-center"
      >
        <div>
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <div class="d-flex flex-row gap-2">
          <div>No cuentas con permisos para acceder a este contenido</div>
          <div>...</div>
        </div>
      </div>
    </div>
  </div>
  <div *appHasPermission="'dashboard_module'" class="h-100">
    <div class="w-100 h-100 d-flex justify-content-center align-content-center">
      <div
        class="d-flex flex-column justify-content-center align-content-center align-items-center"
      >
        <div>
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <div class="d-flex flex-row gap-2">
          <div>Cargando</div>
          <div>datos</div>
          <div>...</div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<toast-license *appHasPermission="'license_module'"></toast-license>
<dialog-license *appHasPermission="'license_module'"></dialog-license>
